/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ title: NonNullable<unknown> }} Feature_ScreenshotInputs */

const en_feature_screenshot = /** @type {(inputs: Feature_ScreenshotInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} feature screenshot`)
};

const fr_feature_screenshot = /** @type {(inputs: Feature_ScreenshotInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Capture d’écran de la fonctionnalité ${i?.title}`)
};

const de_feature_screenshot = /** @type {(inputs: Feature_ScreenshotInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Screenshot der ${i?.title}-Funktion`)
};

const it_feature_screenshot = /** @type {(inputs: Feature_ScreenshotInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Schermata della funzionalità ${i?.title}`)
};

const ru_feature_screenshot = /** @type {(inputs: Feature_ScreenshotInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Скриншот функции ${i?.title}`)
};

const es_feature_screenshot = /** @type {(inputs: Feature_ScreenshotInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Captura de pantalla de la función ${i?.title}`)
};

const zh_cn2_feature_screenshot = /** @type {(inputs: Feature_ScreenshotInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} 功能截图`)
};

const ja_feature_screenshot = /** @type {(inputs: Feature_ScreenshotInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} 機能のスクリーンショット`)
};

const hi_feature_screenshot = /** @type {(inputs: Feature_ScreenshotInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} फ़ीचर स्क्रीनशॉट`)
};

const pt_pt2_feature_screenshot = /** @type {(inputs: Feature_ScreenshotInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Captura de tela do recurso ${i?.title}`)
};

/**
* | output |
* | --- |
* | "{title} feature screenshot" |
*
* @param {Feature_ScreenshotInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const feature_screenshot = /** @type {((inputs: Feature_ScreenshotInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Feature_ScreenshotInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_feature_screenshot(inputs)
	if (locale === "de") return de_feature_screenshot(inputs)
	if (locale === "it") return it_feature_screenshot(inputs)
	if (locale === "ru") return ru_feature_screenshot(inputs)
	if (locale === "es") return es_feature_screenshot(inputs)
	if (locale === "zh-CN") return zh_cn2_feature_screenshot(inputs)
	if (locale === "ja") return ja_feature_screenshot(inputs)
	if (locale === "hi") return hi_feature_screenshot(inputs)
	if (locale === "pt-PT") return pt_pt2_feature_screenshot(inputs)
	return en_feature_screenshot(inputs)
});